import { call, put, takeLatest } from 'redux-saga/effects';
import { getDnsSetup } from 'api/DnsSetupAPI';
import { addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import type { DnsFetchResponse } from './types';

export function* fetchDnsSetupSaga() {
  try {
    const data: DnsFetchResponse = yield call(getDnsSetup);
    yield put(actions.fetchDnsSetupResponse(data));
  } catch (error) {
    yield put(actions.fetchDnsSetupError());
    const message = `Please try again later. If the problem persists, contact your CSM.`;
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([takeLatest(actionTypes.FETCH_DNS_SETUP_REQUEST, fetchDnsSetupSaga)]);
